import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fab from '@material-ui/core/Fab';
import BackIcon from '@material-ui/icons/ArrowBack';
import { makeStyles } from '@material-ui/styles';
import React from 'react';

type StartCallMaskProps = {
  start: () => Promise<void>;
  goBack: () => void;
  numStreams: number;
  patientAttendeeName: string | null;
};

export const StartCallMask = ({
  start,
  goBack,
  numStreams,
  patientAttendeeName,
}: StartCallMaskProps) => {
  const classes = useStyles();

  return (
    <div className={classes.mask}>
      <Button variant="contained" color="primary" onClick={start}>
        Join
      </Button>
      <div className={classes.maskMessage}>
        <div className={classes.maskMessageItem}>Attendees currently in visit: {numStreams}</div>
        {!!patientAttendeeName && (
          <div className={classes.maskMessageItem}>Scheduled Patient: {patientAttendeeName}</div>
        )}
      </div>
      {window.history.length > 1 && (
        <Fab size="small" className={classes.back} onClick={goBack}>
          <BackIcon />
        </Fab>
      )}
    </div>
  );
};

export const ConnectingMask = () => {
  const classes = useStyles();

  return (
    <div className={classes.mask}>
      <CircularProgress className={classes.maskSpinner} />
      <div className={classes.maskMessage}>Connecting</div>
    </div>
  );
};

export const ShowErrorMask = () => {
  const classes = useStyles();

  return (
    <div className={classes.mask}>
      <p>
        An unexpected error while connecting to the call.
        <br />
        Please refresh the page to try again.
      </p>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  back: {
    position: 'absolute',
    top: 20,
    left: 20,
  },
  mask: {
    width: '100%',
    height: '100%',
    position: 'relative',
    color: 'white',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  maskMessage: {
    fontWeight: 500,
    position: 'absolute',
    top: '55%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 20,
  },
  maskMessageItem: {
    marginBottom: 15,
  },
  maskSpinner: {
    position: 'absolute',
  },
}));
